<template>
  <div class="date-selects-model">
    <div class="date-selects-model-title" v-if="title">{{ title }}</div>
    <ul class="date-selects-model-weeks">
      <li
        :class="{
          'date-selects-model-weeks-item': true,
          active: selected.consult_schedule.indexOf(v.value) > -1
        }"
        v-for="(v, i) in list.weeks"
        :key="i"
        @click="hanldeSchedule(v)"
      >
        <p class="title">{{ v.name }}</p>
        <p class="desc">{{ v.week }}</p>
      </li>
    </ul>

    <div class="date-selects-model-times">
      <selectsItem
        v-for="(v, i) in list.times"
        :name="v.name"
        :selected="selected.time.indexOf(v.value) > -1"
        :key="i"
        :size="160"
        @click.native.prevent="handleTime(v)"
        >{{ v.name }}</selectsItem
      >
    </div>

    <buttons
      v-if="showBtns"
      :btns="[
        { label: '重置', onClick: reset },
        { label: '确定', onClick: submit }
      ]"
    />
  </div>
</template>

<script>
import selectsItem from 'app/web/component/consult/listCommon/selectsItem.vue'
import buttons from 'app/web/component/consult/listCommon/buttons.vue'
export default {
  components: {
    selectsItem,
    buttons
  },
  props: {
    value: {
      type: Object
    },
    title: {
      type: String,
      default: '咨询时段（可多选）'
    },
    list: {
      type: Object
    },
    showBtns: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selected: {
        consult_schedule: [],
        time: ['']
      }
    }
  },
  mounted() {
    this.$watch(
      () => this.value,
      val => {
        const { consult_schedule, time } = val
        this.selected.consult_schedule = consult_schedule
          ? consult_schedule.split(',')
          : []
        if (time) {
          this.selected.time = time.split(',')
        }
      },
      {
        deep: true,
        immediate: true
      }
    )
  },
  methods: {
    hanldeSchedule(v) {
      const { value } = v
      const { consult_schedule } = this.selected

      if (consult_schedule.includes(value)) {
        this.selected.consult_schedule = consult_schedule.filter(
          v => v !== value
        )
      } else {
        this.selected.consult_schedule.push(value)
      }
    },
    handleTime(v) {
      const { value } = v
      const { time } = this.selected

      if (value) {
        this.selected.time = time.filter(v => v !== '')
        if (time.includes(value)) {
          this.selected.time = time.filter(v => v !== value)
        } else {
          this.selected.time.push(value)
        }
      } else {
        this.selected.time = ['']
      }
      // selected.time = v.value
    },
    reset() {
      this.selected = {
        consult_schedule: [],
        time: ['']
      }
    },
    submit() {
      // const { weeks } = this.list
      let { time, consult_schedule } = this.selected
      consult_schedule = consult_schedule
        .sort(
          (a, b) =>
            +new Date(a.replace(/-/gi, '/')) - +new Date(b.replace(/-/gi, '/'))
        )
        .join(',')

      let options = {
        time: time.join(','),
        consult_schedule: consult_schedule
      }
      // if (consult_schedule === [weeks[0].value, weeks[1].value].join(',')) {
      //   options.sort = undefined
      // } else if (!options.sort) {
      //   options.sort = ''
      // }

      this.$emit('change', options)
    }
  },
  computed: {}
}
</script>

<style lang="scss">
.date-selects-model {
  // padding-top: 15px;
  &-title {
    line-height: 26px + 29px + 29px;
    padding: 30px 32px 0;

    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 700;
    color: #21252d;
  }

  &-weeks {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    padding: 0 32px;

    &-item {
      width: 90px;
      height: 101px;
      background: #f3f4f5;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      &.active {
        background: #6982fa;
        .title,
        .desc {
          color: #fff;
        }
      }
    }

    .title {
      font-size: 30px;
      color: #21252d;
      line-height: 42px;
    }
    .desc {
      font-size: 22px;
      color: #9da3ac;
      line-height: 34px;
    }
  }

  &-times {
    padding-bottom: 50px;
    display: flex;
    justify-content: space-between;
    padding: 0 32px 50px;

    .select-item {
      margin: 0;
    }

    // margin-bottom: 50px;

    // &-item {
    //   width: 160px;
    //   height: 60px;
    //   background: #f3f4f5;
    //   border-radius: 40px;
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    //   &.active {
    //     background: #6982fa;
    //     .title {
    //       color: #fff;
    //     }
    //   }
    // }

    // .title {
    //   font-size: 30px;
    //   color: #21252d;
    //   line-height: 42px;
    // }
  }
}
</style>
